module.exports = __webpack_public_path__ + "src/img/editPicClose.44f23071.svg";